<template>
	<v-dialog persistent @click:outside="closeDialog()" v-model="dialog" max-width="700" scrollable content-class="test-class">
		<v-form ref="form" @submit.prevent="validate">
			<v-card >
				<v-card-title>
					{{ title }}
					<v-btn icon @click="closeDialog()" class="ml-auto">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text :key="key" class="py-3">
					<label for="attach-poll__question" class="bold">Pytanie</label>
						<v-text-field id="attach-poll__question" v-model="fields.question" :rules="[rules.required, rules.questionLength]" ref="questionInput" outlined elevation="0" dense counter="100" />
					<div v-for="(answer, index) in fields.answers" :key="index" class="mt-3">
						<label for="attach-poll__question" class="bold">Opcja {{ index + 1 }}</label>
						<div class="d-flex flex-row">
							<v-text-field :id="`attach-poll__answer${index + 1}`" v-model="fields.answers[index].answer" ref="answerInput" outlined elevation="0" dense counter="50" :rules="[rules.required, rules.answerLength]"/>
							<v-btn v-if="index > 1" @click="removeOption(index)" icon class="mt-1"><v-icon>mdi-delete</v-icon></v-btn>
						</div>
					</div>
					<div class="text-center mt-3">
						<v-btn :disabled="fields.answers.length >= pollValidation.answers" color="accent" elevation="0" @click="addOption()"><v-icon>mdi-plus</v-icon> {{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.poll.addOption')}}</v-btn>
					</div>
					<div class="mt-5">
						<div class="bold">
							{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.poll.time')}}
						</div>
						<date-time-picker @selected="dateSelected" :date="fields.finishAt" />
					</div>
					<div class="mt-3">
						<v-switch
							v-model="fields.allowCustom"
							color="accent"
							:value="true"
							:label="$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.poll.allow')"
						></v-switch>
					</div>
				</v-card-text>
				<v-card-actions class="justify-content-right py-7 px-5">
					<v-btn color="light" elevation="0" @click="closeDialog()">{{ $vuetify.lang.t('$vuetify.goBack') }}</v-btn>
					<v-btn color="accent" elevation="0" type="submit">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.poll.summary')}}</v-btn>
				</v-card-actions>
			</v-card>
		</v-form>
	</v-dialog>
</template>

<script>
import DateTimePicker from '@/components/pickers/DateTimePicker'
import {mapGetters} from 'vuex';
export default {
	components: {
		DateTimePicker
	},
	props: {
		edit: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			dialog: false,
			key: 0,
			fields: {
				question: '',
				answers: [
					{answer: ''},
					{answer: ''}
				],
				allowCustom: false,
				finishAt: null
			},
			rules: {
				required: value => !!value || 'Pole wymagane.',
				questionLength: v => v && v.length <= 100 || 'Za długi wpis',
				answerLength: v => v.length <= 50 || 'Za długi wpis'
			},
			showDatepicker: false
		}
	},
	computed: {
		...mapGetters({
			pollValidation: 'validation/poll'
		}),
		title() {
			if(!this.edit) {
				return this.$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.poll.header');
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.poll.editPoll')
		},
		finalModel() {
			// Change here when api available
			return this.fields;
		},
		endTime() {
			if(this.fields.finishAt.date) {
				let d = `${this.fields.finishAt.date}`;
				if(this.fields.finishAt.time && this.fields.finishAt.time !== true) {
					d += ` ${this.fields.finishAt.time}`
					return this.$moment(d).local().format('LLLL');
				}
				else {
					return this.$moment(d).local().format('LL');
				}
			}
			return false;
		}
	},
	methods: {
		dateSelected(date) {
			this.fields.finishAt = date;
		},
		validate() {
			if(this.$refs.form.validate()) {
				this.save();
				return;
			}

			this.$toast.error('Wypełnij wymagane pola')
		},
		addOption() {
			if(this.fields.answers.length < this.pollValidation.answers) {
				this.fields.answers.push({answer:''});
				this.$nextTick(() => {
					this.$refs.answerInput[this.fields.answers.length - 1].focus();
				});
			}
		},
		removeOption(index) {
			if(this.fields.answers.length > 2) {
				this.fields.answers.splice(index, 1);
			}
		},
		save() {
			this.$emit('selected', this.finalModel);
			this.closeDialog();
			return true;
		},
		showDialog() {
			this.dialog = true;
		},
		setPoll(poll) {
			this.clear();
			if(poll) {
				this.fields = {
					question: poll && poll.question ? poll.question : null,
					answers: [],
					allowCustom: poll && poll.allowCustom ? poll.allowCustom : null,
					finishAt: poll && poll.finishAt ? poll.finishAt : null
				};
				if(poll.answers && poll.answers.length) {
					poll.answers.forEach(x => {
						this.fields.answers.push({
							id: x.id || null,
							answer: x.answer || ''
						})
					})
				}
				
				
			}
			
			
			this.showDialog();
		},
		closeDialog() {
			this.dialog = false;
			this.clear();
			this.$emit('closed');
		},
		clear() {
			this.fields = {
				question: '',
				answers: [
					{answer: ''},
					{answer: ''}
				],
				allowCustom: false,
				finishAt: null
			},
			this.key++;
		}
	},
	mounted() {
		this.clear();
	}
}
</script>
